import axios from "axios";
import { NewRepository, Repository } from "./repository";
const resource = "HappyCall";
const happyCallRepo = {
    getProductList, getQuestionList, registerHappyCall
};

function registerHappyCall(payLoad, token) {
    return Repository().post(`${resource}/registerHappyCall`, payLoad, token);
}
function getQuestionList(payLoad) {
    return Repository().get(`${resource}/questionlist?${payLoad}`);
}
function getProductList(payLoad) {
    return Repository().get(`${resource}/productlist?${payLoad}`);
}
export default happyCallRepo;